import React from "react";

const GoBackIcon = (props: any) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M16.18 2C19.83 2 22 4.17 22 7.81V16.18C22 19.82 19.83 21.99 16.19 21.99H7.81C4.17 22 2 19.83 2 16.19V7.81C2 4.17 4.17 2 7.81 2H16.18Z"
        fill="#3D68FF"
      />
      <path
        d="M8.76945 8.97859L9.09945 8.64859C9.38945 8.35859 9.38945 7.87859 9.09945 7.58859C8.80945 7.29859 8.32945 7.29859 8.03945 7.58859L6.46945 9.15859C6.17945 9.44859 6.17945 9.92859 6.46945 10.2186L8.03945 11.7886C8.18945 11.9386 8.37945 12.0086 8.56945 12.0086C8.75945 12.0086 8.94945 11.9386 9.09945 11.7886C9.38945 11.4986 9.38945 11.0186 9.09945 10.7286L8.83945 10.4686H13.9195C15.1995 10.4686 16.2495 11.5086 16.2495 12.7986C16.2495 14.0886 15.2095 15.1286 13.9195 15.1286H8.99945C8.58945 15.1286 8.24945 15.4686 8.24945 15.8786C8.24945 16.2886 8.58945 16.6286 8.99945 16.6286H13.9195C16.0295 16.6286 17.7495 14.9086 17.7495 12.7986C17.7495 10.6886 16.0295 8.97859 13.9195 8.97859H8.76945Z"
        fill="white"
      />
    </svg>
  );
};

export default GoBackIcon;
